import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const areaSlice = createSlice({
  name: "area",
  initialState: {
    areas: [],
    refetch: false,
  },
  reducers: {
    getArea: (state, action) => {
      state.areas = action.payload;
    },
    refetch: (state) => {
      state.refetch = !state.refetch;
    },
  },
});

export const { getArea, refetch } = areaSlice.actions;

export const createArea = (formData) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/area/create/v1`;
    const response = await axios.post(url, formData, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Area created successfully");
    dispatch(refetch(true));
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const updateArea = (id, formData) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/area/update/${id}/v1`;
    const response = await axios.put(url, formData, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Area updated successfully");
    dispatch(refetch(true));
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const deleteArea = (id, setIsLoading, setDeleteModal) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/area/delete/${id}/v1`;
    await axios.delete(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Area deleted successfully");
    setIsLoading(false);
    setDeleteModal(false);
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message);
    setIsLoading(false);
    setDeleteModal(false);
  }
};

export const changeAreaStatus = (id) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/area/change/status/${id}/v1`;
    await axios.put(url, {}, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Area Status Updated Successfully");
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const getAreaList = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    const url = `${BASE_URL}/area/list/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(getArea(data.data));
    setLoading(false);
  } catch (error) {
    setLoading(false);
    toast.error(error.response.data.message);
  }
};

export default areaSlice.reducer;
